<template>
    <feature-flag-app>
        <v-container data-app>
            <!-- <v-content> -->
            <v-layout row wrap>
                <v-flex md4 xs12 id="navBarVertical">
                    <nav class="sidebar-sticky" id="navigation">
                        <div class="avatar" data-full-story>
                            <v-avatar size="48" v-if="mobileView == false">
                                <v-img :src="profilePic" aspect-ratio="1" />
                            </v-avatar>
                            <div class="name" data-full-story>
                                <span>{{
                                    displayName
                                        ? displayName
                                        : !!account.names
                                            ? account.names.local
                                            : ''
                                }}</span>
                                <!-- <span>{{!!account.names && account.names.local}}</span> -->
                                <div class="account-id">{{ account.id }}</div>
                            </div>
                        </div>
                        <ul
                            id="appNav"
                            class="nav flex-column"
                            @mouseover="openMenu()"
                            @mouseleave="menuToggle = false"
                            @click.native.stop.prevent
                            :class="{ show: menuToggle }"
                        >
                            <router-link
                                v-if="marketConfigBooleanByName('enablePersonal')"
                                to="/personal"
                                tag="li"
                                class="nav-item"
                                id="personalInfo"
                                @click.native="toggleMenu()"
                            >
                                <span class="icon icon-1"></span>
                                <a href="#" class="nav-link">{{ txc.personal_info }}</a>
                            </router-link>

                            <router-link
                                v-if="marketConfigBooleanByName('enableCommunications')"
                                to="/communications"
                                tag="li"
                                class="nav-item"
                                id="communications"
                                @click.native="toggleMenu()"
                            >
                                <span class="icon icon-2"></span>
                                <a href="#" class="nav-link">{{ txc.communication_prefs }}</a>
                            </router-link>

                            <router-link
                                to="/privacy"
                                tag="li"
                                class="nav-item"
                                id="privacy"
                                @click.native="toggleMenu()"
                            >
                                <span class="icon icon-5"></span>
                                <a href="#" class="nav-link">{{ txc.privacy }}</a>
                            </router-link>

                            <router-link
                                v-if="marketConfigBooleanByName('enableAddress')"
                                to="/address"
                                tag="li"
                                class="nav-item"
                                id="shippingAddress"
                                @click.native="toggleMenu()"
                            >
                                <span class="icon icon-3"></span>
                                <a href="#" class="nav-link">{{ txc.address }}</a>
                            </router-link>

                            <router-link
                                v-if="marketConfigBooleanByName('enablePayment')"
                                to="/payment"
                                tag="li"
                                class="nav-item"
                                id="payments"
                                @click.native="toggleMenu()"
                            >
                                <span class="icon icon-4"></span>
                                <a href="#" class="nav-link">{{ txc.payment_methods }}</a>
                            </router-link>

                            <router-link
                                v-if="marketConfigBooleanByName('enableOrderHistory')"
                                to="/orders"
                                tag="li"
                                class="nav-item"
                                id="orderHistory"
                                @click.native="toggleMenu()"
                            >
                                <span class="icon icon-6"></span>
                                <a href="#" class="nav-link">{{ txc.order_history }}</a>
                            </router-link>

                            <router-link
                                v-if="
                                    marketConfigBooleanByName('enableDirectDeposit') &&
                                        !hideDirectDeposit
                                "
                                to="/direct-deposit"
                                tag="li"
                                class="nav-item"
                                id="directDeposit"
                                @click.native="toggleMenu()"
                            >
                                <span class="icon icon-8"></span>
                                <a href="#" class="nav-link">{{ txc.direct_deposit }}</a>
                            </router-link>

                            <router-link
                                v-if="marketConfigBooleanByName('enableFavorites')"
                                to="/favorites"
                                tag="li"
                                class="nav-item"
                                id="favorites"
                                @click.native="toggleMenu()"
                            >
                                <span class="icon icon-7"></span>
                                <a href="#" class="nav-link">{{ txc.favorites }}</a>
                            </router-link>
                        </ul>
                    </nav>
                </v-flex>
                <v-flex md8 xs12>
                    <email-verify-card v-show="isEmailCardShowing"/>
                    <keep-alive :include="['orderView']">
                        <router-view />
                    </keep-alive>
                </v-flex>
            </v-layout>
            
        </v-container>
    </feature-flag-app>
</template>

<script>
import { ProfileService, UserService } from '@nuskin/ns-account'
import { mapGetters, mapActions } from 'vuex'
import { StringService } from '@nuskin/ns-util'
import profileUtils from './repositories/profileUtils';
import { FeatureFlagApp, UsesFeatureFlags } from '@nuskin/ns-feature-flags-vue'
import Stack from './helpers/contentStackService'
import contentStackService from './helpers/contentStackService.js';
import EmailVerifyCard from './components/EmailVerifyCard';
import defaultStrings from './store/modules/defaultStrings.js';

export default {
    components: {
        FeatureFlagApp,
        EmailVerifyCard
    },
    mixins: [UsesFeatureFlags],
    data() {
        
        return {
            posts: [],
            name: '',
            distId: '',
            sponsorID: '',
            menuToggle: false,
            hidePersonalInfo: false,
            hideCommunications: false,
            hideShippingAddress: false,
            hidePayment: false,
            hideOrderHistory: false,
            hideOrderDetails: true,
            hideDirectDeposit: false,
            hideFavorites: false,
            emailVerifyTrigger: false,
            translations: {},
            ddExplanationId: 'bltbd729a62d036e746',
            ddAgreeToTermsId: 'blt96ddf91342280c5a',
            smsTermsId: 'blt1335ee4ac4a6f35f',
            sharedStrings: 'blta3557d9c831beda7'
        }
    },
    computed: {
        ...mapGetters({
            mobileView: 'mobileView',
            txc: 'translationsCategories',
            marketConfigBooleanByName: 'marketConfigBooleanByName',
            displayName: 'displayName',
            profilePic: 'profilePic',
            account: 'account',
            addressLocal: 'localAddress',
            marketLoggedIn: 'marketLoggedIn',
            isHomeMarket: 'isHomeMarket',
            isDistributor: 'isDistributor',
            isRetailCustomer: 'isRetailCustomer',
            isMember: 'isMember',
            marketConfig: 'marketConfig',
            isEmailVerified: 'isEmailVerified',
            isResendVerifyEmail: 'isResendVerifyEmail',
            isEmailSentHavingIssue: 'isEmailSentHavingIssue',
            isEmailCardShowing: 'isEmailCardShowing',
            sponsorId: 'sponsorId'
        }),
        email() {
            return UserService.getUser().email
        }
        
    },
    methods: {
        ...mapActions([
            'updatePreferredName',
            'updateProfilePic',
            'setAccount',
            'setSponsor',
            'setCommonStrings',
            'updateIsDistributor',
            'updateHUTaxInfo',
            'setLanguageList',
            'setCategoriesStrings',
            'setPersonalStrings',
            'setPrivacyStrings',
            'setSharedStrings',
            'updateAllowThirdGender',
            'setCommunicationStrings',
            'setSmsTerms',
            'setFavoriteStrings',
            'setDirectDepositStrings',
            'setOrderHistoryStrings',
            'setPaymentMethodStrings',
            'setDirectDepositExplanationTerms',
            'setDirectDepositAgreementTerms',
            'setEmailVerified',
            'setEmailSentHavingIssue',
            'setResendVerifyEmail',
            'setEmailCardShowing',
            'setUsernameStatus',
            'setModified',
            'setUsername',
            'setPendingStatus',
            'setPendingUsername'
        ]),
        checkEmailPattern (username) {
            // eslint-disable-next-line security/detect-unsafe-regex, max-len
            const pattern = /^[\s]*[A-Za-z0-9!#$%&*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?[\s]*$/;
            return pattern.test(username)
        },
        toggleMenu() {
            this.menuToggle = !this.menuToggle
        },
        getSponsor() {
            return this.sponsorId;
        },
        closeMenu() {
            // hack because router-link last child doesn't fire <ul/> mouseover event
            if (this.menuToggle) {
                this.menuToggle = false
            } else {
                this.menuToggle = true
            }
        },
        async loadFeatureFlags() {
            await this.$features.$waitForLoad();
        },
        openMenu() {
            /**
       *  this is a hack, check if another menu is open while nav menu is, then close it.
       *  off click event of prev open menu doesn't work when ul menu is clicked.
       *  it could be because vuetify navigation-drawer is not being used?
       */
            let openMenu = document.getElementsByClassName(
                'menuable__content__active'
            )[0]
            if (openMenu) {
                openMenu.style.display = 'none'
                openMenu.classList.remove('menuable__content__active')
            }
            this.menuToggle = true
        }
    },
    watch: {
    /**
     * This code is necessary so that order History is displayed when Order details is clicked,
     * but removed when navigated away.
     */
        $route(to, from) {
            document
                .getElementById('orderHistory')
                .classList.remove('router-link-exact-active', 'active')
        }
    },
    async created() {
        await this.loadFeatureFlags()
        let self = this
        
        let common_strings = [
            { key: 'show', dflt: 'show' },
            { key: 'hide', dflt: 'hide' },
            { key: 'passwordRequired', dflt: 'Password is required' },
            {
                key: 'excludesWhitespaceChars',
                dflt: 'Password must not include spaces'
            },
            { key: 'includes8chars', dflt: 'Use 8 or more characters' },
            { key: 'includesUpper', dflt: 'Use an upper case letter (e.g. A)' },
            { key: 'includesLower', dflt: 'Use a lower case letter (e.g. a)' },
            { key: 'includesNumber', dflt: 'Use a number (e.g. 1234)' },
            { key: 'includesSpecialChars', dflt: 'Use a symbol (e.g. !@#$)' },
            {
                key: 'passwordConditionsMet',
                dflt:
          'Password must include 8 characters at least 3 of the other 4 below'
            },
            { key: 'criteriaComplete', dflt: 'Your password is STRONG' },
            {
                key: 'validationRequirement',
                dflt:
          'Password must include 8 characters at least 3 of the other 4 below'
            },
            { key: 'dontIncludeNames', dflt: 'Don\'t Include First, Last, or username in password' },
            { key: 'dontReusePassword', dflt: 'You cannot reuse a previous password' },
            { key: 'newPasswordNotCurrent', dflt: 'New password cannot be your current password' },
            { key: 'networkError', dflt: 'Network Error' },
            { key: 'invalidCharInName', dflt: 'Invalid Characters in Name' },
            { key: 'passwordLength', dflt: 'Limit Password to 72 characters' },
            { key: 'fieldRequired', dflt: 'This field is required' },
            { key: 'invalidPhoneField', dflt: 'Invalid Phone Number Format' }
        ]
     
        StringService.getStrings(common_strings).then((response) => {
            self.setCommonStrings(response);
        }).then(
            self.setCommonStrings(defaultStrings.commonStrings)
        );
        
        try {
            Stack.getEntry('profile_categories').then((strings) => {
                const updatedCategoryStrings = Stack.replaceEmptyStringsWithDefaultStrings(
                    strings, defaultStrings.categories)
                this.setCategoriesStrings(updatedCategoryStrings[0])
            }).catch(() => {
                this.setCategoriesStrings(defaultStrings.categories)
            })
            Stack.getEntry('profile_acct_info').then(async (strings) => {
                const updatedPersonalStrings = Stack.replaceEmptyStringsWithDefaultStrings(
                    strings, defaultStrings.personal)
                this.setPersonalStrings(updatedPersonalStrings[0])
                const sharedStrings = await Stack.getSharedStrings(strings);
                const updatedSharedStrings = Stack.replaceEmptyStringsWithDefaultStrings(
                    sharedStrings, defaultStrings.sharedStrings
                )
                this.setSharedStrings(updatedSharedStrings)
            }).catch(() => {
                this.setPersonalStrings(defaultStrings.personal)
                this.setSharedStrings(defaultStrings.sharedStrings)
            })
            Stack.getEntry('profile_communications').then((strings) => {
                const updatedCommunicationStrings = Stack.replaceEmptyStringsWithDefaultStrings(
                    strings, defaultStrings.communication
                )
                this.setCommunicationStrings(updatedCommunicationStrings[0])
            }).catch(() => {
                this.setCommunicationStrings(defaultStrings.communication)
            })
            Stack.getEntry('profile_privacy').then((strings) => {
                const updatedPrivacyStrings = Stack.replaceEmptyStringsWithDefaultStrings(
                    strings, defaultStrings.privacy
                )
                this.setPrivacyStrings(updatedPrivacyStrings[0])
            }).catch(() => {
                this.setPrivacyStrings(defaultStrings.privacy)
            })
            Stack.getEntry('profile_favorites').then((strings) => {
                const updatedFavoriteStrings = Stack.replaceEmptyStringsWithDefaultStrings(
                    strings, defaultStrings.favorites)
                this.setFavoriteStrings(updatedFavoriteStrings[0])
            }).catch(() => {
                this.setFavoriteStrings(defaultStrings.favorites)
            })
            Stack.getEntry('profile_direct_deposit').then((strings) => {
                const updatedDirectDepositStrings = Stack.replaceEmptyStringsWithDefaultStrings(
                    strings, defaultStrings.directDeposit)
                this.setDirectDepositStrings(updatedDirectDepositStrings[0])
            }).catch(() => {
                this.setDirectDepositStrings(defaultStrings.directDeposit)
            })
            Stack.getEntry('profile_order_history').then((strings) => {
                const updatedOrderHistoryStrings = Stack.replaceEmptyStringsWithDefaultStrings(
                    strings, defaultStrings.orderHistory)
                this.setOrderHistoryStrings(updatedOrderHistoryStrings[0])
            }).catch(() => {
                this.setOrderHistoryStrings(defaultStrings.orderHistory)
            })
            Stack.getEntry('profile_payment_method').then((strings) => {
                const updatedPaymentMethodStrings = Stack.replaceEmptyStringsWithDefaultStrings(
                    strings, defaultStrings.payment)
                this.setPaymentMethodStrings(updatedPaymentMethodStrings[0])
            }).catch(() => {
                this.setPaymentMethodStrings(defaultStrings.payment)
            })
            Stack.getSubEntry('terms_and_conditions', this.ddExplanationId).then((strings) => {
                const updatedDDExplanationStrings = Stack.replaceEmptyStringsWithDefaultStrings(
                    strings, defaultStrings.terms.directDeposit.ddExplantion)
                this.setDirectDepositExplanationTerms(updatedDDExplanationStrings)
            }).catch(() => {
                this.setDirectDepositExplanationTerms(defaultStrings.terms.directDeposit.ddExplantion)
            })
            Stack.getSubEntry('terms_and_conditions', this.ddAgreeToTermsId).then((strings) => {
                const updatedDDTermsStrings = Stack.replaceEmptyStringsWithDefaultStrings(
                    strings, defaultStrings.terms.directDeposit.ddTerms)
                this.setDirectDepositAgreementTerms(updatedDDTermsStrings)
            }).catch(() => {
                this.setDirectDepositAgreementTerms(defaultStrings.terms.directDeposit.ddTerms)
            })
            Stack.getSubEntry('terms_and_conditions', this.smsTermsId).then((strings) => {
                const updatedSmsTermsStrings = Stack.replaceEmptyStringsWithDefaultStrings(
                    strings, defaultStrings.terms.smsTerms)
                this.setSmsTerms(updatedSmsTermsStrings)
            }).catch(() => {
                this.setSmsTerms(defaultStrings.terms.smsTerms)
            })
        } catch (e) {
            console.log('Error in getEntry in App: ', e);
        }

        ProfileService.getAccountInfo(profileUtils.getLanguage()).then(function (response) {
           
            self.setAccount(response.data.account);
            self.setSponsor(response.data.account.sponsorID);
            self.getSponsor();
            ProfileService.getLanguageList(profileUtils.getLanguage(), response.data.account.country)
                .then(function (languageList) {
                    self.setLanguageList(languageList);
                });
            if (response.data.account.country === 'HU' && response.data.account.beType === 'DIST') {
                ProfileService.getHUTaxInfo().then(function (response) {
                    self.updateHUTaxInfo(response);
                });
            }
            if (self.account.beType !== 'DIST') {
                self.hideDirectDeposit = true
            }
        })
        
        ProfileService.getVGGreeting().then(function (response) {
            self.updatePreferredName(response.data.alias)
        }).catch({});
        self.updateProfilePic(UserService.getUser().photoURL)
        const username = UserService.getUser().username;

        if(this.$features['cx13-15592-enable-email-verify-feature']) {
            try {
                const verifyStatus = await profileUtils.verifyStatus();

                if (!this.checkEmailPattern(username)) {
                    this.setUsernameStatus(false)
                }

                if(!verifyStatus) {
                    this.setUsername(username)
                    this.setPendingUsername(username)
                    this.setEmailCardShowing(true)
                } else if (verifyStatus && verifyStatus.verified) {
                    this.setEmailVerified(verifyStatus.verified)
                    this.setUsername(verifyStatus.email)
                    const isNotificationConfirmed = localStorage.getItem('successNotificationConfirmed');
                    this.setEmailCardShowing(!isNotificationConfirmed)
                    if(verifyStatus.email !== username) {
                        let currentUser = UserService.getUser()
                        currentUser.username = verifyStatus.email;
                        UserService.setUser(currentUser)
                    }
                } else {
                    this.setPendingStatus(true)
                    this.setUsername(username)
                    this.setPendingUsername(verifyStatus.email)
                    this.setEmailCardShowing(true)
                    if(verifyStatus.email !== username) this.setModified(true)
                }
            } catch (e) {
                console.log('Error in EmailVerified function in App: ', e);
            }
        } else {
            this.setUsername(username)
        }

        const hash = window.location.hash
        switch (hash) {
            case '#/communications':
                this.$router.push('/communications').catch(err => {})
                break
            case '#/privacy':
                this.$router.push('/privacy').catch(err => {})
                break
            case '#/address':
                this.$router.push('/address').catch(err => {})
                break
            case '#/payment':
                this.$router.push('/payment').catch(err => {})
                break
            case '#/orders':
                this.$router.push('/orders').catch(err => {})
                break
            case '#/favorites':
                this.$router.push('/favorites').catch(err => {})
                break
            default:
                if (hash && hash.includes('#/orderDetail')) {
                    this.$router.push(hash.slice(1)).catch(err => {})
                } else {
                    this.$router.push('/personal').catch(err => {})
                }
        }
        contentStackService.getConfig('profile_config')
            .then((config) => {
                this.updateAllowThirdGender(config.allowThirdGender)
            })
    },
    async mounted() {
        this.loadFeatureFlags()
        this.getSponsor();
    }
}
</script>

<style lang="scss">
@import '~@nuskin/ns-core-styles/src/scss/forms';
@import '~@nuskin/ns-core-styles/src/scss/typography';
@import '~@nuskin/ns-core-styles/src/scss/buttons';
@import '~@nuskin/ns-core-styles/src/scss/colors';
@import '~@nuskin/ns-core-styles/src/scss/vuetifyOverrides';
@import './scss/style.scss';

.v-date-picker-table table td {
    padding: 0px;
}

.v-date-picker-table table td button.accent div {
  color: black;
  background: lightgreen;
}

#content {
  padding-bottom: 6px;
}

.modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  div {
    padding: 15px 0;
  }
}
// }

ul#appNav li.nav-item {
  flex-flow: row nowrap;
  height: 44px;
  line-height: 44px;
}

ul#appNav li.nav-item .icon {
  width: 22px;
}

.v-avatar {
  margin-right: 10px;
  padding: 15px 0;
}

.v-input__icon.v-input__icon--append {
  /* align-items:center; */
  /* display:inline-flex; */
  flex: 1 0 auto;
  justify-content: center;
  width: unset;
  height: unset;
}

.avatar {
  .account-id {
    color: $nsCorpGray;
    font-size: 14px;
    line-height: 18px;
    font-weight: 100;
  }
}

// TODO MOVE VUETIFY OVERRIDES TO VUETIFYOVERRIDES.CSS unless it is project specific
.theme--light.v-card {
  border: 1px solid map-get($baseColors, gandalf);
  @media screen and (max-width: 768px) {
    border-left: none;
    border-right: none;
  }
}

.v-dialog__content--active {
  button.modal--close .icon {
    margin: 0;
  }
}

.v-select {
  &__selection {
    color: rgba(0, 0, 0, 0.87); // mathcing other inputs (i.e. text-field)
    font-weight: 300; // matching other inputs (i.e. text-field)
  }

  // override vuetify style on bottom of input
  .v-input__control .v-input__slot {
    border: 1px solid map-get($baseColors, eyore); // matching other inputs (i.e. text-field)
    padding: 0 5px;
    // override vuetify style on bottom of input
    &:before {
      border: none;
    }

    .v-select__slot {
      flex-flow: unset;

      .v-select__selections {
        // override aem overrides
        .v-select__selection--comma {
          position: unset;
          top: unset;
          left: unset;
          transform: unset;
        }

        // override aem style for input border
        input {
          border: none;
        }
      }

      // override aem overrides
      .v-input__append-inner {
        position: unset;
        top: unset;
        right: unset;
        bottom: unset;
        z-index: 20;
        // override aem overrides
        @media screen and (max-width: 480px) {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          margin-top: 0;
        }
      }
    }
  }
}

.sidebar-sticky {
  .nav-item a.nav-link:hover {
    text-decoration: none;
  }

  .sponsor-wrapper {
    margin-top: 30px;
  }
}

@media screen and (max-width: 480px) {
  .v-input input:not([type]),
  .v-input input[type='text'],
  .v-input input[type='tel'],
  .v-input input[type='date'],
  .v-input input[type='search'],
  .v-input input[type='number'],
  .v-input input[type='password'],
  .v-input input[type='email'] {
    min-height: 45px;
  }
}

@media screen and (max-width: 768px) {
  input {
    min-height: inherit;
  }

  aside {
    margin-bottom: 20px;
  }

  .sidebar-sticky .nav-item .nav-link {
    display: block;
    width: 100%;
    line-height: 30px;
  }

  ul#appNav {
    margin: 15px;
    width: calc(100% - 30px);
    border: solid 1px map-get($baseColors, gandalf);
  }
}

.ns-atomic h2 {
  font-family: unset;
}

.v-bottom-sheet {
  .container {
    .wrapper {
      justify-content: flex-end;
      .close {
        right: -40px;
      }
    }
  }
}

.v-dialog {
  .modal-content {
    padding: 25px 0;
  }
}

/* fix issue with screen width ACCT-5261 */
@media only screen and (min-width: 768px) {
  .container {
    max-width: 97%;
  }
}

@media print {
  [class*='SliderContainer'] {
    display: none !important;
    visibility: hidden !important;
  }

  #mainContainer .container {
    max-width: 7in;
  }

  #navigation {
    display: none !important;
    visibility: hidden !important;
  }
  #orderHeader {
    display: none !important;
    visibility: hidden !important;
  }
}
</style>
